import { Amplify } from 'aws-amplify';
import awsconfig from '../aws-exports';


Amplify.configure({
    ...awsconfig,
    "aws_cloud_logic_custom": [
        {
            "name": "identx",
            endpoint: process.env.REACT_APP_API_BASE_URL,
            region: process.env.REACT_APP_AWS_REGION,
        }
    ],
    API: {
        REST: {
            identx: {
                endpoint: process.env.REACT_APP_API_BASE_URL,
                region: process.env.REACT_APP_AWS_REGION,
            }
        }
    }
});


/**
 * endpoints: [
          {
            name: 'identx',
            endpoint: process.env.REACT_APP_API_BASE_URL,
            region: process.env.REACT_APP_AWS_REGION,
          },
        ],
 */